var data = [
  {
    path: "/oversee/holiday",
    component: () => import("@/gongwuche/config/config")
  },
  {
    path: "/oversee/train",
    component: () => import("@/gongwuche/doc/doc.vue")
  },
  {
    path: "/oversee/check",
    component: () => import("@/gongwuche/doc/kaoqin.vue")
  },
  {
    path: "/oversee/leave",
    component: () => import("@/gongwuche/doc/diaodujilu.vue")
  },
  {
    path: "/oversee/driver",
    component: () => import("@/gongwuche/doc/chuxingtongji.vue")
  },
  {
    path: "/oversee/car",
    component: () => import("@/gongwuche/doc/cheliangtongji.vue")
  },
  {
    path: "/oversee/notTaskRpt",
    component: () => import("@/gongwuche/doc/wurenwu.vue")
  },
  {
    path: "/oversee/holidayRpt",
    component: () => import("@/gongwuche/doc/jiejiari.vue")
  },
  {
    path: "/data/buy",
    component: () => import("@/gongwuche/caigou/caigou.vue")
  }
  //新的
  ,
 {
   path: "/liuchengSiji",
    component: () => import("@/gongwuche/liucheng/liuchengpeizhi.vue")
 }

  
];
export default data;



// WEBPACK FOOTER //
// ./src/router/gongwuche.js